import { Box, TextField } from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type InvoicesSearchParams = {
  searchTerm: string;
};

type SearchFormProps = {
  searchTerm: string;
  search: (searchParams: InvoicesSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const BankSearchForm: FC = ({ searchTerm, search }: SearchFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountAndBilling.InvoicesAndStatements' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);

  return (
    <Box flx="row" gap="sm" wrap="wrap">
      <TextField
        key="InvoiceKeyword"
        name="InvoiceKeyword"
        placeholder={t('InvoiceSearchForm.inputPlaceholder')}
        value={currentSearchTerm}
        onBlur={() => {}}
        onChange={(e) => {
          setCurrentSearchTerm(e.target.value);
        }}
        variant="outlineShadow"
      />
      <Button
        id="search-invoice"
        size="large"
        colorScheme="primary"
        onClick={() => {
          search({
            searchTerm: currentSearchTerm,
          });
        }}
      >
        {tGlobal('Buttons.search')}
      </Button>
    </Box>
  );
};

export default BankSearchForm;
